export const createVisitor = (userId = null) => {
  if (userId) userId += '';
  return {
    visitorId: userId,
    context: {},
    isAuthenticated: !!userId,
  };
};
